import { makeStyles } from '@mui/styles';
import { CustomTheme } from 'types/theme';

export const useStyles = makeStyles((theme: CustomTheme) => ({
  icon: {
    height: 20,
    width: 20,
    borderRadius: '100%',
    background: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  facebookComponent: {
    width: '100%',
    border: 'none',
    fontSize: '15px',
    fontFamily: 'Nunito',
    fontWeight: '700',
    letterSpacing: '0.46px',
    height: '54px',
    borderRadius: '4px',
    background: 'transparent',
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    '&:hover': {
      cursor: 'pointer'
    },
  },
}));
